import { createCarryLink, createORPCClient, type CarryApiClient } from "@carry/client";

/**
 * admin の oRPC クライアント。
 * Better-Auth が httpOnly Cookie で session を管理するため、
 * credentials:'include' で cookie を API 側へ送る。
 *
 * 契約型 (CarryApiClient) で型付けし、全ルートが contract を単一の型源泉として使えるようにする。
 */
export function createAdminApi(): CarryApiClient {
  const baseUrl = import.meta.env.VITE_API_URL ?? "http://localhost:8080";
  const link = createCarryLink({ baseUrl, credentials: "include" });
  return createORPCClient<CarryApiClient>(link);
}

export type AdminApi = CarryApiClient;
